import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import PublicHeader from '../../components/common/PublicHeader';
import PublicFooter from '../../components/common/PublicFooter';

const ScoreKeepingPageV3 = () => {
  useEffect(() => {
    document.title = 'Keeping Score | SportsTMS | THE OFFICIAL SPORTS MANAGEMENT SYSTEM';
  }, []);

  return (
    <div id="outer_m">
      <PublicHeader />

      {/* Main Content */}
      <div id="main">
        {/* Social Media Sticky Icons */}
        <div id="stickleft">
          <i className="fa fa-facebook-square" style={{fontSize:'32px', marginLeft:'2px', cursor:'pointer', color:'#022a5e'}}></i>
          <i className="fa fa-youtube-square" style={{fontSize:'32px', marginLeft:'2px', cursor:'pointer', color:'#022a5e'}}></i>
          <i className="fa fa-twitter-square" style={{fontSize:'32px', marginLeft:'2px', cursor:'pointer', color:'#022a5e'}}></i>
          <i className="fa fa-linkedin-square" style={{fontSize:'32px', marginLeft:'2px', cursor:'pointer', color:'#022a5e'}}></i>
        </div>

        <Link to="/rules">
          <div id="stick_right"></div>
        </Link>

        {/* Section 1 */}
        <div id="basic">
          <div id="keep">
            <h3 className="heading3050">How to Keep Score</h3>
            <p className="depart_p">
              Different fans have different methods of keeping a scorecard, and many use their own notations. 
              But here's a simple method:
            </p>
            <h3 className="heading3040">Symbols for Play</h3>
            <br />
            <img className="ks1" src="/ks1.jpg" alt="Baseball Scoring Symbols" />
          </div>
        </div>

        {/* Section 2 */}
         <div id="basic">
          <div id="keep1">
            <p className="depart_p">
              <img className="ks2" src="/ks2.jpg" alt="Scorecard Example" style={{ float: 'left', marginRight: '15px' }} />
            If the hitter grounds out to shortstop, for example, write in "6-3," which shows the shortstop threw him out at first base. If the hitter flies out to left field, write a "7." If the batter gets a hit, write in the hit according to which base he reached. Each corner of the box represents a base, with the lower-right corner being first. If he singles, put a "-" in the lower right. If he doubles, write a "=" in the upper right, and so on. For a walk, use "BB" in the lower right. As the runner advances, mark the appropriate symbol in the appropriate corner <br/> <br/>If a runner scores, put a circle at the bottom of the box, and inside the circle put the symbol of the play and/or the player that drove him in. For example, if the No. 5 hitter drives in two runs with a single, mark his single in the bottom right of his box and mark a circle with the number "5" in it in the boxes of the runners who score (Some people like to use uniform numbers here, so you can tell who did what, even after lineup changes). At the end of each inning, total the hits and runs for that inning only. At the end of the game you'll be able to add the innings total to get the game score.
            </p>

            <h3 className="heading3040">Example Scorecard</h3>
            <img className="ks1" src="/ks3.jpg" alt="Complete Scorecard Example" />
          </div>
        </div>

        
      </div>

      <PublicFooter />
    </div>
  );
};

export default ScoreKeepingPageV3;